<template>
  <component
    :is="currentView"
    transition-mode="out-in"
    @transitionend.stop
    @continue="next"
  />
</template>

<script>
import RemindForm from "./Form";
import Success from "./Success";

export default {
  name: "auth-password-reminder",
  components: { RemindForm, Success },
  data: function() {
    return {
      currentStep: 0,
      steps: ["RemindForm", "Success"]
    };
  },
  computed: {
    currentView() {
      return this.steps[this.currentStep];
    }
  },
  methods: {
    next() {
      this.currentStep += 1;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
